module.exports = __webpack_public_path__ + "img/title-page-img.8d48b030.png";